/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { Row, Col } from 'react-grid-system';
import { useNavigate, useLocation } from "react-router-dom";
import { DatePicker } from 'rsuite';
import InputGroup from 'react-bootstrap/InputGroup';
import 'rsuite/dist/rsuite.min.css';
import Cookies from 'universal-cookie';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import MetaTags from 'react-meta-tags';

let checkScheme = (scheme) => {
	let responseText = "";
	if (scheme === 0)
		responseText = "單次購買";
	else if (scheme === 1)
		responseText = "月費制";
	else if (scheme === 2)
		responseText = "小時制";

	return responseText;
}

let ModalComponent = (props) => {
	return (
		<Modal show={props.show} onHide={() => props.onHide()}>
			<Modal.Header closeButton>
				<Modal.Title>{props.title}</Modal.Title>
			</Modal.Header>
			<Modal.Body>{props.content}</Modal.Body>
			<Modal.Footer>
				<Button variant="secondary" onClick={() => props.onHide()}>
					取消
				</Button>
				<Button variant="primary" onClick={() => { props.handler(props.param) }}>
					是
				</Button>
			</Modal.Footer>
		</Modal>
	)
}
function PersonalInformationProtection(props) {
	if (props.data !== null || props.data !== ""){
		var info = props.data
		if (props.data.includes("@")){
			var secComponentData = props.data.split("@")[1]
			var thirdComponentData = secComponentData.split(".")[1]
			return props.data.substring(0,2) + "***@" + secComponentData.substring(0,1) + "***." +  thirdComponentData
		}else if (/^\d+$/.test(props.data)){
			
			if (info.length === 10){
				return info.substring(0,4) + "*" + info.substring(5,6) + "*" + info.substring(7,8) + "*" + info.substring(9,10)
			}
		}else if (props.data.toString().match(/[\u3400-\u9FBF]/)){
			
			var result = ""
			for (let i=0; i < info.length; i++){
				if (i===0 || i === info.length-1){
					result += info[i] 
				}else{
					result += "o"
				}
					
			}
			return result
		}else {
			return info
		}
	}else{
		return <></>
	}
}
function OrderDetail() {
	const [promoList, setPromoList] = useState([]);
	const [showDialog, setShowDialog] = useState(false);
	const [showDelDialog, setShowDelDialog] = useState(false);
	const [delContractUUID, setDelContractUUID] = useState(false);
	const [startDate, setStartDate] = useState(undefined);
	const [endDate, setEndDate] = useState(undefined);

	let location = useLocation();
	const cookies = new Cookies();
	const navigate = useNavigate();

	const userInfo = cookies.get("userInfo");

	const [matches414Min, setMatches414Min] = useState(
		window.matchMedia("(min-width: 415px)").matches
	)
	const [matches414Max, setMatches414Max] = useState(
		window.matchMedia("(max-width: 414px)").matches
	)

	const localeLan = {
		sunday: '週日',
		monday: '一',
		tuesday: '二',
		wednesday: '三',
		thursday: '四',
		friday: '五',
		saturday: '六',
		ok: '關閉',
		today: '今天',
		yesterday: '昨天',
		hours: '時',
		minutes: '分',
		seconds: '秒'
	}

	function handleDelectEvent(contract_uuid) {
		setDelContractUUID(contract_uuid);
		setShowDelDialog(true)
	}

	function transferDateFormat(d) {
		if (d != null) {
			var ds = /-/g;
			//console.log(d);
			let dateSec1 = d.toISOString().split("T")[0];
			//dateSec1 = dateSec1.replace(ds,'/');

			return dateSec1;
		}

	}

	function getContractList() {
		let isComponentMounted = true;
		const fetchData = async () => {
			const apiUrl = "/order/GetContractsList";
			let apiParams = {};
			let requestOptions = {};
			let collapsePromoObj = [];

			if (startDate !== undefined && endDate !== undefined) {
				apiParams = {
					"access_token": cookies.get("auth_access_token"),
					"start_date": transferDateFormat(startDate),
					"end_date": transferDateFormat(endDate)
				};
			} else {
				apiParams = {
					"access_token": cookies.get("auth_access_token")
				};
			}
			requestOptions = {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify(apiParams)
			};

			const response = await fetch("/api" + apiUrl, requestOptions)
			const r = await response.json();

			//console.log(r.results);
			if (isComponentMounted) {
				setPromoList(r.results);
			}
		}
		fetchData();
		return () => {
			isComponentMounted = false;
		}
	}

	function checkState(contract_uuid, val, pay_type, index) {
		let message = "";
		if (val === 4 && pay_type === 1)
			message = <span
				style={{ color: "#374d58", fontWeight: "700", textDecoration: "underline", cursor: "pointer" }}
				onClick={() => handleDelectEvent(contract_uuid)} >退租</span>;
		else if (val === 4 && pay_type !== 1)
			message = "已完成訂單"
		else if (val === 0 || val === 1 || val === 2)
			message = <span
				style={{ color: "#374d58", fontWeight: "700", textDecoration: "underline", cursor: "pointer" }}
				onClick={() => navigate('/pay', { state: { promoInfo: promoList[index] } })} >未付款</span>
		else if (val === 5)
			message = "訂單已取消"
		else if (val === 6 || val === 9 || val === 10 || val === 11)
			message = "退租處理中";
		else if (val === 7)
			message = "小額退款成功";
		else if (val === 8)
			message = "小額退款失敗";
		else if (val === 12)
			message = "已退租";

		return message;
	}

	function handleCancelSubscription(obj) {
		const contract_uuid = obj.contract_uuid;
		if (contract_uuid !== undefined && contract_uuid !== "") {
			setShowDelDialog(false);
			let isComponentMounted = true;
			const fetchData = async () => {
				const apiUrl = "/order/DelContract";
				let apiParams = {};
				let requestOptions = {};
				let collapsePromoObj = [];
				apiParams = {
					"access_token": cookies.get("auth_access_token"),
					"contract_uuid": contract_uuid
				};
				requestOptions = {
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify(apiParams)
				};
				const response = await fetch("/api" + apiUrl, requestOptions)
				const r = await response.json();

				//console.log(r.results);
				if (r.isSuccess === 1)
					navigate("/container/order_list");
				//setPromoList(r.results);
			}
			fetchData();
			return () => {
				isComponentMounted = false;
			}
		}
	}

	function onHide() {
		setShowDelDialog(false);
	}

	useEffect(() => {
		const script = document.createElement('script');
		if (process.env.REACT_APP_DEV_ENV === "dev")
			script.src = "https://s3.hicloud.net.tw/cpmaker-stg/b75aff59-2634-45b2-ae41-764f60b1bbc2.js";
		else if (process.env.REACT_APP_DEV_ENV === "stage")
			script.src = "https://s3.hicloud.net.tw/cpmaker-stg/b75aff59-2634-45b2-ae41-764f60b1bbc2.js";
		else if (process.env.REACT_APP_DEV_ENV === "prod")
			script.src = "https://s3.hicloud.net.tw/cpmaker/988fa3ee-e5ef-4bf9-82ff-32f2ea832f16.js";

		script.async = true;
		document.body.appendChild(script);
		return () => {
			document.body.removeChild(script);
		}
	}, []);

	useEffect(() => {
		if (cookies.get("auth_access_token") === undefined || cookies.get("auth_access_token") === "") {
			setShowDialog(true);
		}
		if (cookies.get("auth_access_token") !== undefined && userInfo === undefined)
			window.location.reload();

		window
			.matchMedia("(min-width: 415px)")
			.addEventListener('change', e => setMatches414Min(e.matches));
		window
			.matchMedia("(max-width: 414px)")
			.addEventListener('change', e => setMatches414Max(e.matches));
		getContractList();
	}, [location]);

	return (
		<div className="content_inpage">
			<MetaTags>
				<title>中華電信AI語意雲延伸應用-會員中心-訂單查詢</title>
				<meta name="keywords" content="i寶貝會員中心,訂單查詢,訂單狀態確認,取消訂單,訂單詳細資料,退租"></meta>
				<meta name="description" content="提供會員查詢管理的訂單，包含：確認訂單狀態、了解訂單詳情、取消訂單等。" />
				<meta property="og:title" content="中華電信AI語意雲延伸應用-會員中心-訂單查詢" />
				<meta property="og:Description" content="提供會員查詢管理的訂單，包含：確認訂單狀態、了解訂單詳情、取消訂單等。" />
				<meta property="og:image" content="https://ibobby.ai.hinet.net/app_icons/app_banner/imgUpload_d491a04b-9662-439d-a287-934eabb746a0.jpg" />
			</MetaTags>
			<div className="pagesize">

				<ul className="bread">
					<li><a href="/">首頁</a></li>
					<li><a href="commodity_01_01.html">會員中心</a></li>
				</ul>
				<div className="tab_con">
					<div className="tab_box active">
						<h2 className="tit_main">訂單查詢-訂單詳細</h2>
						<div className="content_box commodity_box">
							{matches414Min && (
								<>
									<InputGroup style={{ width: "600px", color: "black !important", float: "left" }} className="mb-3">
										<DatePicker onChange={setStartDate} block appearance="subtle" placeholder="選擇日期" oneTap
											format="yyyy-MM-dd"
											locale={localeLan}
											style={{ color: "black", width: 230, border: "1px solid #ced4da", borderRadius: "10px 0 0 10px" }} />
										<InputGroup.Text id="basic-addon1">至</InputGroup.Text>
										<DatePicker onChange={setEndDate} block appearance="subtle" placeholder="選擇日期" oneTap
											format="yyyy-MM-dd"
											locale={localeLan}
											style={{ color: "black", width: 230, border: "1px solid #ced4da", borderRadius: "0 10px 10px 0" }} />
									</InputGroup>
									<div className="btn btn-search" onClick={() => getContractList()}>
										搜尋
									</div>
								</>
							)}
							{matches414Max && (
								<>
									<InputGroup style={{ width: "300px", color: "black !important", float: "left" }} className="mb-3">

										<DatePicker onChange={setStartDate} block appearance="subtle" placeholder="選擇日期" oneTap
											format="yyyy-MM-dd"
											locale={localeLan}

											style={{ color: "black", width: 230, border: "1px solid #ced4da", borderRadius: "10px 0 0 10px" }} />
										<InputGroup.Text id="basic-addon1">至</InputGroup.Text>

										<DatePicker onChange={setEndDate} block appearance="subtle" placeholder="選擇日期" oneTap
											format="yyyy-MM-dd"
											locale={localeLan}
											style={{ color: "black", width: 230, border: "1px solid #ced4da", borderRadius: "10px 10px 10px 10px" }} />

									</InputGroup>
									<div style={{ width: "300px", marginBottom: "20px" }} className="btn btn-search" onClick={() => getContractList()}>
										搜尋
									</div>
								</>
							)}

							{matches414Min && (
								<div className="table_box">
									<table border="0" cellPadding="0" cellSpacing="0">
										<tbody>
											{promoList.map((item, index) =>
												<div key={index}>
													<tr >
														<th className="sty01">會員編號</th>
														<td> <PersonalInformationProtection data = {userInfo.userName}/></td>
													</tr>
													<tr>
														<th width="15%">訂單日期</th>
														<th width="10%">訂單編號</th>
														<th width="15%">優惠方案名稱</th>
														<th width="15%">服務到期日</th>
														<th width="15%">優惠方案類型</th>
														<th width="5%">數量</th>
														<th width="5%">訂單總額</th>
														<th width="10%">付款方式</th>
														<th width="10%">訂單狀態</th>
													</tr>
													<tr>
														<td width="15%">{item.create_time}</td>
														<td width="10%">{item.order_no}</td>
														<td width="15%">{item.promo_name}</td>
														<td width="15%">{item.end_time}</td>
														<td width="15%">{checkScheme(item.pay_type)}</td>
														<td width="5%">{item.amount}</td>
														<td width="5%">{item.price}</td>
														<td width="10%">信用卡</td>
														<td width="10%">{checkState(item.uuid, item.state, item.pay_type, index)}</td>
													</tr>
													<tr rowSpan={2}>
														<td colSpan={9}>
															<Row>
																<span className="circle_solid" style={{ position: "relative", left: "8%" }}></span>
																<span className="line" style={{ position: "relative", left: "8%" }}></span>
																<span className="circle_solid" style={{ position: "relative", left: "8%" }}></span>
																<span className="line" style={{ position: "relative", left: "8%" }}></span>
																<span className={item.state >= 4 ? "circle_solid" : "circle_hollow"} style={{ position: "relative", left: "8%" }}></span>
															</Row>
															<Row>
																<Col xs={2}>訂單成立時間</Col>
																<Col xs={3}></Col>
																<Col xs={2}>訂單處理中</Col>
																<Col xs={3}></Col>
																<Col xs={2}>{item.state >= 4 ? "訂單已完成" : "訂單尚未完成"}</Col>
															</Row>
															<Row>
																<Col xs={2}>{item.create_time}</Col>
																<Col xs={3}></Col>
																<Col xs={2}>{item.create_time}</Col>
																<Col xs={3}></Col>
																<Col xs={2}></Col>
															</Row>
														</td>
													</tr>
													<tr>
														<td colSpan={9} style={{ textAlign: "left", color: "#AE5252", fontWeight: "700" }}>
															<div dangerouslySetInnerHTML={{ __html: item.promo_name === "商務版月租方案" ? "(1) 同帳號不可重複購買 「商務、雲市集」方案，一個帳號僅能創建一個問答服務(技能) <br />(2) 訂閱完成請至<a style='display:inline' href='https://ibobbymaker.ai.hinet.net'>AI知識中心服務網站</a>使用聊天機器人平台服務" : "" }}></div>
															<div dangerouslySetInnerHTML={{ __html: (item.promo_name === "免費體驗方案" || item.promo_name === "小時訂閱方案" || item.promo_name === "容量訂閱方案") ? "(1) 依消保法規，非以有形媒介提供之數位內容或一經提供即為完成之線上服務，不適用 7 日鑑賞期，售出後恕無法受理退換；本公司已於商店購物說明主動告知所售產品屬於消保法第 19 條所述之合理例外情事，故不在 7 日鑑賞期規範內，敬請見諒。<br />(2)購買的方案是綁定在付款的帳號，不同帳號之間，方案無法移轉或共享。<br />(3)同帳號，可同時購買「小時或容量」方案，系統會優先以較優惠的容量機制計算使用量(若您先購入小時訂閱方案，之後再新購入容量訂閱方案，之前以時數計費的音檔容量將「不會」被計算在內)<br />(4)訂閱完成請至<a style='display:inline' href='https://voicefilter.ai.hinet.net'>AI聲音濾鏡網站</a>" : "" }}></div>
															<div dangerouslySetInnerHTML={{ __html: (item.promo_name === "免費試用方案") ? "(1)每個中華會員帳號僅限申請一次<br />(2) 訂購完成請至<a style='display:inline' href='https://aibroadcast.ai.hinet.net'>AI廣播助理服務網站</a>，並以購買的中華電信會員帳號登入及使用<br />(3) 虛擬音箱需綁定中華電信會員帳號，並以該帳號登入AI廣播助理服務網站，方可使用" : "" }}></div>
															<div dangerouslySetInnerHTML={{ __html: (item.promo_name === "輕量版月租方案" || item.promo_name === "超值版月租方案") ? "(1) 訂購完成請至<a style='display:inline' href='https://aibroadcast.ai.hinet.net'>AI廣播助理服務網站</a>，並以購買的中華電信會員帳號登入及使用<br />(3) 虛擬音箱需綁定中華電信會員帳號，並以該帳號登入AI廣播助理服務網站，方可使用" : "" }}></div>
														</td>
													</tr>
												</div>
											)}
										</tbody>
									</table>
								</div>
							)}
							{matches414Max && (
								<div className="table_box">
									<table border="0" cellPadding="0" cellSpacing="0">
										<tbody>
											{promoList.map((item, index) =>
												<div key={index}>
													<tr >
														<th className="sty01">會員編號</th>
														<td>{userInfo ? userInfo.userName : <></>}</td>
													</tr>
													<tr>
														<th width="15%">訂單日期</th>
														<td width="15%">{item.create_time}</td>
													</tr>
													<tr>
														<th width="10%">訂單編號</th>
														<td width="10%">{item.order_no}</td>
													</tr>
													<tr>
														<th width="15%">優惠方案名稱</th>
														<td width="15%">{item.promo_name}</td>
													</tr>
													<tr>
														<th width="15%">服務到期日</th>
														<td width="15%">{item.end_time}</td>
													</tr>
													<tr>
														<th width="15%">優惠方案類型</th>
														<td width="15%">{checkScheme(item.pay_type)}</td>
													</tr>
													<tr>
														<th width="5%">數量</th>
														<td width="5%">{item.amount}</td>
													</tr>
													<tr>
														<th width="5%">訂單總額</th>
														<td width="5%">{item.price}</td>
													</tr>
													<tr>
														<th width="10%">付款方式</th>
														<td width="10%">信用卡</td>
													</tr>
													<tr>
														<th width="10%">訂單狀態</th>
														<td width="10%">{checkState(item.uuid, item.state, item.pay_type, index)}</td>
													</tr>
													<tr>
														<td colSpan={9} style={{ textAlign: "left", color: "#AE5252", fontWeight: "700" }}>
															<div dangerouslySetInnerHTML={{ __html: item.promo_name === "商務版月租方案" ? "(1) 同帳號不可重複購買 「商務、雲市集」方案，一個帳號僅能創建一個問答服務(技能) <br />(2) 訂閱完成請至<a style='display:inline' href='https://ibobbymaker.ai.hinet.net'>AI知識中心服務網站</a>使用聊天機器人平台服務" : "" }}></div>
															<div dangerouslySetInnerHTML={{ __html: (item.promo_name === "免費體驗方案" || item.promo_name === "小時訂閱方案" || item.promo_name === "容量訂閱方案") ? "(1) 依消保法規，非以有形媒介提供之數位內容或一經提供即為完成之線上服務，不適用 7 日鑑賞期，售出後恕無法受理退換；本公司已於商店購物說明主動告知所售產品屬於消保法第 19 條所述之合理例外情事，故不在 7 日鑑賞期規範內，敬請見諒。<br />(2)購買的方案是綁定在付款的帳號，不同帳號之間，方案無法移轉或共享。<br />(3)同帳號，可同時購買「小時或容量」方案，系統會優先以較優惠的容量機制計算使用量(若您先購入小時訂閱方案，之後再新購入容量訂閱方案，之前以時數計費的音檔容量將「不會」被計算在內)<br />(4)訂閱完成請至<a style='display:inline' href='https://voicefilter.ai.hinet.net'>AI聲音濾鏡網站</a>" : "" }}></div>
															<div dangerouslySetInnerHTML={{ __html: (item.promo_name === "免費試用方案") ? "(1)每個中華會員帳號僅限申請一次<br />(2) 訂購完成請至<a style='display:inline' href='https://aibroadcast.ai.hinet.net'>AI廣播助理服務網站</a>，並以購買的中華電信會員帳號登入及使用<br />(3) 虛擬音箱需綁定中華電信會員帳號，並以該帳號登入AI廣播助理服務網站，方可使用" : "" }}></div>
															<div dangerouslySetInnerHTML={{ __html: (item.promo_name === "輕量版月租方案" || item.promo_name === "超值版月租方案") ? "(1) 訂購完成請至<a style='display:inline' href='https://aibroadcast.ai.hinet.net'>AI廣播助理服務網站</a>，並以購買的中華電信會員帳號登入及使用<br />(3) 虛擬音箱需綁定中華電信會員帳號，並以該帳號登入AI廣播助理服務網站，方可使用" : "" }}></div>
														</td>
													</tr>
												</div>
											)}
										</tbody>
									</table>

								</div>
							)}
							<ModalComponent
								show={showDelDialog}
								title="退租服務"
								content="確認是否進行退租"
								param={{ contract_uuid: delContractUUID }}
								handler={handleCancelSubscription}
								onHide={onHide}>
							</ModalComponent>
							<Modal show={showDialog} onHide={() => setShowDialog(false)}>
								<Modal.Header closeButton>
									<Modal.Title>請先登入</Modal.Title>
								</Modal.Header>
								<Modal.Body>登入後才可查看訂單</Modal.Body>
								<Modal.Footer>
									<Button variant="primary" onClick={() => { navigate("/login", { state: { lastPage: "/container/order_list", paramObj: {} } }); }}>
										確認
									</Button>
								</Modal.Footer>
							</Modal>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default OrderDetail;